<script setup lang="ts">
import { computed } from "vue";

import { cardActions } from "@/action/cardActions";
import { cardKey } from "@/components/StickyNote/injectKeys";
import { dropdownKey } from "@/components/ui/DropdownMenu/injectKeys";
import type { Art } from "@/model/session";
import { useArtStore } from "@/store/art";
import { injectStrict } from "@/utils/vue";

import ArtSelector from "../../../ArtSelector/ArtSelector.vue";

const card = injectStrict(cardKey);
const dropdown = injectStrict(dropdownKey);

const arts = computed(() => useArtStore().arts);
const selected = computed(() => arts.value.find((art) => art.id === card.artId));

const handleArtChange = (art: Art | null) => {
  cardActions.setArt("action-menu", card.id, art?.id ?? null);
  dropdown.close();
};
</script>

<template>
  <ArtSelector class="change-art" :selected :arts @select="handleArtChange" />
</template>
